module.exports = __webpack_public_path__ + "static/media/home-img-charts@2x.fa1fe416.png";